// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var GraphQL_PPX = require("@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_City = require("../../../shared/src/types/CommonTypes_City.bs.js");
var CommonTypes_Email = require("../../../shared/src/types/CommonTypes_Email.bs.js");
var WebTypes_Business = require("./WebTypes_Business.bs.js");
var CommonTypes_User_Id = require("../../../shared/src/types/CommonTypes_User_Id.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var CommonTypes_PhoneNumber = require("../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var CommonTypes_ProfileableType = require("../../../shared/src/types/CommonTypes_ProfileableType.bs.js");

var Raw = {};

var query = "fragment WebTypes_User on User   {\n...CommonTypes_User_Name   \nbusiness  {\n...WebTypes_Business   \n}\n\ncity  {\n...CommonTypes_City   \n}\n\nemail  \nid  \nphoneNumber  \nprofileableType  \n}\n" + CommonTypes_City.query + CommonTypes_User_Name.query + WebTypes_Business.query;

function parse(value) {
  var value$1 = value["business"];
  var value$2 = value["city"];
  var value$3 = value["email"];
  return {
          commonTypes_User_Name: CommonTypes_User_Name.verifyArgsAndParse("CommonTypes_User_Name", value),
          business: !(value$1 == null) ? WebTypes_Business.verifyArgsAndParse("WebTypes_Business", value$1) : undefined,
          city: CommonTypes_City.verifyArgsAndParse("CommonTypes_City", value$2),
          email: !(value$3 == null) ? Caml_option.some(CommonTypes_Email.GraphQL_API.parse(value$3)) : undefined,
          id: CommonTypes_User_Id.GraphQL_API.parse(value["id"]),
          phoneNumber: CommonTypes_PhoneNumber.GraphQL_API_FromString.parse(value["phoneNumber"]),
          profileableType: CommonTypes_ProfileableType.GraphQL_API.parse(value["profileableType"])
        };
}

function serialize(value) {
  var value$1 = value.profileableType;
  var value$2 = CommonTypes_ProfileableType.GraphQL_API.serialize(value$1);
  var value$3 = value.phoneNumber;
  var value$4 = CommonTypes_PhoneNumber.GraphQL_API_FromString.serialize(value$3);
  var value$5 = value.id;
  var value$6 = Curry._1(CommonTypes_User_Id.GraphQL_API.serialize, value$5);
  var value$7 = value.email;
  var email = value$7 !== undefined ? Curry._1(CommonTypes_Email.GraphQL_API.serialize, Caml_option.valFromOption(value$7)) : null;
  var value$8 = value.city;
  var city = CommonTypes_City.serialize(value$8);
  var value$9 = value.business;
  var business = value$9 !== undefined ? WebTypes_Business.serialize(value$9) : null;
  return [CommonTypes_User_Name.serialize(value.commonTypes_User_Name)].reduce(GraphQL_PPX.deepMerge, {
              business: business,
              city: city,
              email: email,
              id: value$6,
              phoneNumber: value$4,
              profileableType: value$2
            });
}

function verifyArgsAndParse(_WebTypes_User, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var business = param.business;
  var name = param.commonTypes_User_Name;
  if (business === undefined) {
    return ;
  }
  var email = param.email;
  if (email === undefined) {
    return ;
  }
  var phoneNumber = param.phoneNumber;
  var id = param.id;
  var email$1 = Caml_option.valFromOption(email);
  var city = param.city;
  return Relude_Option.map((function (business) {
                return {
                        business: business,
                        city: CommonTypes_City.tToR(city),
                        email: email$1,
                        id: id,
                        name: name,
                        phoneNumber: phoneNumber
                      };
              }), WebTypes_Business.tToR(business));
}

var Business = {
  tToR: tToR
};

function business(param_0) {
  return /* Business */{
          _0: param_0
        };
}

function tToR$1(businessUser) {
  var match = businessUser.profileableType;
  if (typeof match === "number") {
    if (match >= 3) {
      return /* Professional */0;
    } else {
      return Relude_Option.fold(/* Unknown */1, business, tToR(businessUser));
    }
  } else {
    return /* Unknown */1;
  }
}

var professional = /* Professional */0;

var unknown = /* Unknown */1;

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.Business = Business;
exports.business = business;
exports.professional = professional;
exports.unknown = unknown;
exports.tToR = tToR$1;
/* Relude_Option Not a pure module */
